import { Message, MessageMetadata } from '../../types/chat';
import localforage from 'localforage';

const messageStorage = localforage.createInstance({
    name: 'GoPlausible-Algorand-Agency',
    storeName: 'messages-metadata',
    version: 1.0,
    description: 'Algorand Agency platform message storage'
});


export const messageMetadataStore = {

    // Get message metadata from local storage
    async getMessageMetadata(messageId: string) {
        try {
            const metadata = await messageStorage.getItem(messageId);
            if (!metadata) return null;
            return metadata
        } catch (error) {
            console.error('Error getting message metadata:', error);
            return null;
        }
    },

    // Save message metadata to local storage
    async saveMessageMetadata(messageId: string, metadata: MessageMetadata) {
        try {
            await messageStorage.setItem(messageId, metadata);
        } catch (error) {
            console.error('Error saving message metadata:', error);
        }
    },

    // Extract and save metadata from a message
    async extractAndSaveMetadata(message: Message) {
        if (!message.id) return;
        const metadata: MessageMetadata = {};
        if (message.metadata?.workflow_info) {
            metadata.workflow_info = message.metadata.workflow_info;
        }
        if (message.metadata?.usage) {
            metadata.usage = message.metadata.usage;
        }
        await this.saveMessageMetadata(message.id, metadata)
    },
    // Clear all message metadata
    async clearAllMessageMetadata() {
        try {
            await messageStorage.clear();
        } catch (error) {
            console.error('Error clearing message metadata:', error);
        }
    }


}
